import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const RadarCreatorHub = () => {
  const navigate = useNavigate();
  const [creatorProfile, setCreatorProfile] = useState({
    name: '',
    bio: '',
    website: '',
    socialLinks: {
      twitter: '',
      linkedin: '',
      github: ''
    },
    categories: []
  });
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const profileData = {
        id: 'me',
        name: creatorProfile.name,
        bio: creatorProfile.bio,
        website: creatorProfile.website,
        socialLinks: creatorProfile.socialLinks,
        categories: creatorProfile.categories,
        imageUrl: logo ? URL.createObjectURL(logo) : 'https://ui-avatars.com/api/?name=' + encodeURIComponent(creatorProfile.name) + '&background=007bff&color=fff',
        totalDownloads: 0,
        averageRating: 0,
        lastActivity: new Date().toISOString(),
        tools: []
      };
      localStorage.setItem('creatorProfile', JSON.stringify(profileData));
      navigate('/business-tool-marketplace/creator/me');
    } catch (err) {
      setError('Failed to save profile. Please try again.');
      console.error('Error saving profile:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleLogoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setLogo(e.target.files[0]);
    }
  };

  return (
    <div className="creator-hub">
      <div className="creator-hub-header">
        <h1>Set Up Your Creator Profile</h1>
      </div>
      <div className="profile-section">
        <h2>Creator Profile</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleProfileSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              value={creatorProfile.name}
              onChange={(e) => setCreatorProfile({ ...creatorProfile, name: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="bio">Bio</label>
            <textarea
              id="bio"
              value={creatorProfile.bio}
              onChange={(e) => setCreatorProfile({ ...creatorProfile, bio: e.target.value })}
              rows={4}
            />
          </div>
          <div className="form-group">
            <label htmlFor="logo">Profile Picture</label>
            <input
              type="file"
              id="logo"
              accept="image/*"
              onChange={handleLogoChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="website">Website</label>
            <input
              type="url"
              id="website"
              value={creatorProfile.website}
              onChange={(e) => setCreatorProfile({ ...creatorProfile, website: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Social Links</label>
            <input
              type="url"
              placeholder="Twitter URL"
              value={creatorProfile.socialLinks.twitter}
              onChange={(e) => setCreatorProfile({
                ...creatorProfile,
                socialLinks: { ...creatorProfile.socialLinks, twitter: e.target.value }
              })}
            />
            <input
              type="url"
              placeholder="LinkedIn URL"
              value={creatorProfile.socialLinks.linkedin}
              onChange={(e) => setCreatorProfile({
                ...creatorProfile,
                socialLinks: { ...creatorProfile.socialLinks, linkedin: e.target.value }
              })}
            />
            <input
              type="url"
              placeholder="GitHub URL"
              value={creatorProfile.socialLinks.github}
              onChange={(e) => setCreatorProfile({
                ...creatorProfile,
                socialLinks: { ...creatorProfile.socialLinks, github: e.target.value }
              })}
            />
          </div>
          <div className="form-group">
            <label>Categories</label>
            <div className="categories-input">
              <input
                type="text"
                placeholder="Add a category"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    const input = e.target;
                    const value = input.value.trim();
                    if (value && !creatorProfile.categories.includes(value)) {
                      setCreatorProfile({
                        ...creatorProfile,
                        categories: [...creatorProfile.categories, value]
                      });
                      input.value = '';
                    }
                  }
                }}
              />
              <div className="categories-list">
                {creatorProfile.categories.map((category, index) => (
                  <span key={index} className="category-tag">
                    {category}
                    <button
                      type="button"
                      onClick={() => setCreatorProfile({
                        ...creatorProfile,
                        categories: creatorProfile.categories.filter((_, i) => i !== index)
                      })}
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            </div>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Saving...' : 'Save Profile'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RadarCreatorHub; 